// This Image component accepts either an explicit url or an image reference.
// This is a temporary measure as we migrate away from passing references to components
import React from 'react'
import imageUrlBuilder from '@sanity/image-url'

import clientConfig from 'client-config'

const Image = ({ url, props, classes, alt, width, maxWidth, height }) => {
  if (!props && !url) {
    return null
  }
  let imageUrl = ''

  // Note: Rather than passing width and height as params to imageBuilder, we
  // pass them through in the img src url. This is due to the imageBuilder
  // placing rect params when both width and height are present which messes
  // with some images' rendering
  if (!url) {
    const imageObj = {
      asset: { _ref: props },
    }
    const imageBuilder = imageUrlBuilder(clientConfig.sanity).image(imageObj)
    imageUrl = imageBuilder.url()
  } else {
    imageUrl = url
  }

  return (
    <img
      loading='lazy'
      src={`${imageUrl}?auto=format&fit=max${
        width && !maxWidth ? `&w=${width}` : ''
      }${maxWidth ? `&w=${maxWidth}` : ''}${height ? `&h=${height}` : ''}`}
      alt={alt || ''}
      className={classes}
      width={width && width !== null ? width : 'auto'}
      height={height && height !== null ? height : 'auto'}
    />
  )
}
export default Image
